export default theme => ({
  userProfile: {

  },
  root: {
    width: '100%'
  },
  panel: {
    marginTop: 10,
    marginBottom: 10
  },
  panelNoMargins: {
    boxShadow: 'none'
  },
  panelSummary: {
    display: 'flex'
  },
  panelSummaryNoMargins: {
    display: 'flex',
    padding: '0px'
  },
  panelSummaryContent: {
    marginRight: '32px !important'
  },
  headingContainer: {
    flex: 1
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    // flexBasis: '33.33%', - use this to have the secondary header
    flexShrink: 3
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  },
  details: {
    display: 'inline-block',
    width: '100%'
  },
  detailsNoMargins: {
    display: 'inline-block',
    width: '100%',
    padding: '0px'
  }
})



// WEBPACK FOOTER //
// ./src/styles/components/collapsible-section.js